export default [
    {
        name: 'refinance.index',
        path: '/refinance',
        component: () => import('@/views/refinance/index.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.goals',
        path: '/refinance/goals',
        component: () => import('@/views/refinance/goals.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.how-plan-to-use-cash',
        path: '/refinance/how-plan-to-use-cash',
        component: () => import('@/views/refinance/how-plan-to-use-cash.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.personal-info',
        path: '/refinance/personal-info',
        component: () => import('@/views/refinance/personal-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.your-info',
        path: '/refinance/your-info',
        component: () => import('@/views/refinance/your-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.connected-with-ae',
        path: '/refinance/connected-with-ae',
        component: () => import('@/views/refinance/connected-with-ae.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.who-is-ae',
        path: '/refinance/who-is-ae',
        component: () => import('@/views/refinance/who-is-ae.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.co-applicant',
        path: '/refinance/co-applicant',
        component: () => import('@/views/refinance/co-applicant.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.coapplicant-contact-info',
        path: '/refinance/coapplicant-contact-info',
        component: () => import('@/views/refinance/coapplicant-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.coapplicant',
        path: '/refinance/coapplicant',
        component: () => import('@/views/refinance/coapplicant.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.your-credit-score',
        path: '/refinance/your-credit-score',
        component: () => import('@/views/refinance/your-credit-score.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.employment-status',
        path: '/refinance/employment-status',
        component: () => import('@/views/refinance/employment-status.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.bankruptcy',
        path: '/refinance/bankruptcy',
        component: () => import('@/views/refinance/bankruptcy.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.home-info',
        path: '/refinance/home-info',
        component: () => import('@/views/refinance/home-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.your-home-address',
        path: '/refinance/your-home-address',
        component: () => import('@/views/refinance/your-home-address.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.estimated-home-value',
        path: '/refinance/estimated-home-value',
        component: () => import('@/views/refinance/estimated-home-value.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.current-mortgage-balance',
        path: '/refinance/current-mortgage-balance',
        component: () => import('@/views/refinance/current-mortgage-balance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.how-much-cash',
        path: '/refinance/how-much-cash',
        component: () => import('@/views/refinance/how-much-cash.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.what-type-home-is',
        path: '/refinance/what-type-home-is',
        component: () => import('@/views/refinance/what-type-home-is.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.how-plan-to-use-it',
        path: '/refinance/how-plan-to-use-it',
        component: () => import('@/views/refinance/how-plan-to-use-it.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.pay-hoa',
        path: '/refinance/pay-hoa',
        component: () => import('@/views/refinance/pay-hoa.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.included-in-mortgage-payments',
        path: '/refinance/included-in-mortgage-payments',
        component: () => import('@/views/refinance/included-in-mortgage-payments.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.property-taxes',
        path: '/refinance/property-taxes',
        component: () => import('@/views/refinance/property-taxes.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.own-or-rent',
        path: '/refinance/own-or-rent',
        component: () => import('@/views/refinance/own-or-rent.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.monthly-mortgage-payment',
        path: '/refinance/monthly-mortgage-payment',
        component: () => import('@/views/refinance/monthly-mortgage-payment.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.monthly-rental-payment',
        path: '/refinance/monthly-rental-payment',
        component: () => import('@/views/refinance/monthly-rental-payment.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.finances',
        path: '/refinance/finances',
        component: () => import('@/views/refinance/finances.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.coapplicant-annual-income',
        path: '/refinance/coapplicant-annual-income',
        component: () => import('@/views/refinance/coapplicant-annual-income.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.yearly-income',
        path: '/refinance/yearly-income',
        component: () => import('@/views/refinance/yearly-income.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.list-your-expenses',
        path: '/refinance/list-your-expenses',
        component: () => import('@/views/refinance/list-your-expenses.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.create-account',
        path: '/refinance/create-account',
        component: () => import('@/views/auth/create-account.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.new-account',
        path: '/refinance/new-account',
        component: () => import('@/views/auth/new-account.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.success',
        path: '/refinance/success',
        component: () => import('@/views/refinance/success.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'refinance.need-more-info',
        path: '/refinance/need-more-info',
        component: () => import('@/views/refinance/need-more-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    }
];
